import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classnames from 'classnames';

export const SECTION_NAME = ['driving', 'comfort', 'interior', 'technology', 'utility', 'mpg', 'value', 'wildcard'];

export function EditorialReviewRating({ ratings, className }) {
  if (SECTION_NAME.every(section => !get(ratings, `[${section}].rating`))) {
    return null;
  }

  return (
    <ul className={classnames('list-unstyled m-0', className)}>
      {SECTION_NAME.map(section => (
        <li key={section} className="d-flex justify-content-between py-0_25">
          <span className="text-capitalize">{section}&nbsp;</span>
          <span className="text-end">{get(ratings, `[${section}].rating`, 'N/A')}</span>
        </li>
      ))}
    </ul>
  );
}

EditorialReviewRating.propTypes = {
  ratings: PropTypes.objectOf(PropTypes.shape({ rating: PropTypes.string })),
  className: PropTypes.string,
};

EditorialReviewRating.defaultProps = {
  ratings: null,
  className: null,
};
